import { FormControl, FormHelperText, Stack, Typography } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { useFormikContext } from "formik";
import React from "react";
import { useIntl } from "react-intl";

import { initialValue } from "../../Form/helpers";
import { QuestionProps } from "../interfaces";

const DateQuestion: React.FC<QuestionProps> = ({ question, saveDraft, ...props }) => {
    const { values, getFieldMeta, errors, setFieldValue } = useFormikContext<Record<string, initialValue>>();
    const error = errors[question.id];
    const { formatMessage } = useIntl();
    let value: string = "";
    const formValue = values[question.id]?.value;
    if (formValue) {
        if (typeof formValue === "string" && formValue.length > 0) {
            value = formValue;
        } else if (Array.isArray(formValue) && formValue.length > 0) {
            value = formValue[0];
        }
    }

    const { touched } = getFieldMeta(`${question.id}.value`);

    return (
        <FormControl error={touched && Boolean(error)}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                    key="questionnaire-date-picker"
                    format="DD MMM YYYY"
                    localeText={{
                        fieldMonthPlaceholder: () => "MMM",
                    }}
                    slotProps={{
                        textField: {
                            placeholder: formatMessage({ defaultMessage: "Select date" }),
                        },
                    }}
                    value={value ? dayjs(value) : null}
                    disabled={props.disabled}
                    onChange={(newValue) => {
                        if (newValue?.isValid() === false) return;
                        setFieldValue(question.id, {
                            value: newValue ? newValue.toISOString() : "",
                            fileNames: values[question.id]?.fileNames ?? [],
                        });
                        if (!newValue) {
                            saveDraft([]);
                            return;
                        }
                        saveDraft([newValue.toISOString()]);
                    }}
                />
            </LocalizationProvider>
            <FormHelperText>
                <Stack direction="row" justifyContent="flex-start">
                    <Typography>{touched && error ? error.value : ""}</Typography>
                </Stack>
            </FormHelperText>
        </FormControl>
    );
};

export default DateQuestion;
